import { PricingItemTypeEnum } from '../../pricing-items/enums/pricing-item-type.enum';

/**
 * Resolves whether a STANDARD pricing item participates in the discount base.
 * Non-STANDARD items never receive the standard discount. Tenant
 * `isStandardDiscountEnabled` is the final gate: when disabled, no STANDARD
 * item is discountable regardless of per-item flags. When enabled, only an
 * explicit per-item flag of `true` applies the discount.
 */
export function resolveIsStandardDiscountApplied(
  itemType: PricingItemTypeEnum,
  explicitFlag: boolean | undefined,
  isStandardDiscountEnabled: boolean,
): boolean {
  if (itemType !== PricingItemTypeEnum.STANDARD) {
    return false;
  }

  if (!isStandardDiscountEnabled) {
    return false;
  }

  return explicitFlag === true;
}
